import React from 'react';
import { StyleSheet, css } from 'aphrodite';

const GalleryHeader = () => {
  return (
    <div className={css(styles.wrapper)}>
      <h3 className={css(styles.heading)}>
        Discover Exquisite Dishes and Captivating Moments
      </h3>

      <p className={css(styles.text)}>
        Indulge in the visual feast of our culinary creations and captivating
        ambiance. Experience the essence of fine dining captured in every image.
      </p>
    </div>
  );
};

export default GalleryHeader;

/* -------------------- STYLES -------------------- */

const styles = StyleSheet.create({
  wrapper: {
    padding: '10rem 2rem 0 2rem',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
    backgroundColor: 'var(--color-cream)',
  },

  heading: {
    fontFamily: 'var(--font-base)',
    color: 'var(--color-green)',
    fontSize: 'clamp(2.8rem,5vw,5rem)',
    fontWeight: 500,
    letterSpacing: '-.03em',
    lineHeight: '1.3',
    marginBottom: '1.5rem',
  

    '@media (max-width: 768px)': {
      fontSize: '28px',
    },

    '@media (max-width: 480px)': {
      fontSize: '24px',
    },
  },

  text: {
    fontFamily: 'var(--font-alt)',
    color: 'var(--color-gray)',
    fontSize: '16px',
    lineHeight: '1.8',
    maxWidth: '720px',
    margin: '0 auto',

    '@media (max-width: 480px)': {
      fontSize: '15px',
    },
  },
});
